import {Injectable} from "@angular/core";
import {ObligorState} from "../model/state/obligor-state";
import {HeaderDetails, Obligor} from "../model/pro-report/HeaderDetails";
import {FilterState} from "../model/state/filter-state";

@Injectable({
    providedIn: 'root'
  }
)
export class ProReportStateService {

  private obligorMap = new Map<number, ObligorState>();

  constructor() {
  }

  public put(obligor: Obligor, headerDetails: HeaderDetails, includeNews: boolean, filterState: FilterState, generatedTime: Date, lastEditedTime: Date) {
    const obj = this.obligorMap.get(obligor.id);
    if (!obj) {
      this.obligorMap.set(obligor.id, new ObligorState(obligor, headerDetails, includeNews, filterState, generatedTime, lastEditedTime));
    } else {
      obj.obligor = obligor;
      obj.headerDetails = headerDetails;
      obj.includeNews = includeNews;
      obj.filterState = filterState;
      obj.generatedTime = generatedTime;
      obj.lastEditedTime = lastEditedTime;
    }
  }

  public get(obligorId: number): ObligorState {
    return this.obligorMap.get(obligorId);
  }

  clear() {
    this.obligorMap.clear();
  }

}
